@if (displayStepper) {
  <div class="stepper-titles">
    @for (step of steps; track step) {
      <div class="step" [ngClass]="{ 'future-step': isFutureStep(step) }">
        {{ step.title }}
      </div>
    }
  </div>
  <div class="stepper">
    @for (step of steps; track step) {
      <div
        class="step"
      [ngClass]="{
        'active-step': isActiveStep(step),
        'completed-step': isCompletedStep(step),
        'future-step': isFutureStep(step)
      }"
        >
        <div class="dot"></div>
      </div>
    }
  </div>
}
